/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  /**
   * Municipalities & Neighborhoods
   */
  municipality: process.env.VUE_APP_MUNICIPALITY,
  neighborhood: process.env.VUE_APP_NEIGHBORHOOD,
  municipalities: {
    almere: {
      id: 'almere',
      label: 'Almere',
      neighborhoods: {
        BU00340106: {
          id: 'BU00340106',
          slug: 'demarken',
          label: 'De Marken'
        }
      }
    },
    hilversum: {
      id: 'hilversum',
      label: 'Hilversum',
      neighborhoods: {
        BU04020602: {
          id: 'BU04020602',
          slug: 'electrobuurt',
          label: 'Electrobuurt'
        },
        BU04020601: {
          id: 'BU04020601',
          slug: 'geuzenbuurt',
          label: 'Geuzenbuurt'
        },
        BU04020603: {
          id: 'BU04020603',
          slug: 'kleinedriftbuurt',
          label: 'Kleine Driftbuurt',
        }
      }, 
    }
  },
  
  /**
   * Display Mode details
   */
  filters: {
    bouwblok: {
      id: 'bouwblok',
      label: 'Bouwblokken (handmatig)',
      items: [] // Special display mode
    },
    'bouwblok-auto': {
      id: 'bouwblok-auto',
      label: 'Bouwblokken (automatisch)',
      items: [] // Special display mode
    },
    barcode: {
      id: 'barcode',
      label: 'Codering',
      items: [{
        id: 'barcode-0',
        label: '',
        active: true,
        color: 'rgb(245, 63, 174)'
      },{
        id: 'barcode-1',
        label: '',
        active: true,
        color: 'rgb(21, 193, 203)'
      }, {
        id: 'barcode-2',
        label: '',
        active: true,
        color: 'rgb(246, 104, 50)'
      }, {
        id: 'barcode-3',
        label: '',
        active: true,
        color: 'rgb(38, 179, 137)'
      }, {
        id: 'barcode-4',
        label: '',
        active: true,
        color: 'rgb(238, 207, 65)'
      }, {
        id: 'barcode-5',
        label: '',
        active: true,
        color: 'rgb(74, 93, 161)'
      }]
    },
    eigendom: {
      id: 'eigendom',
      label: 'Eigendom',
      component: true,
      enabled: true,
      position: 0,
      maporder: 0,
      items: [
        {
          id: 'eigenaar-0',
          code: 1,
          label: '1: Eigenaar bewoner',
          value: 'Eigenaar bewoner',
          active: true,
          color: 'rgb(245, 63, 174)'
        }, 
        {
          id: 'eigenaar-2',
          code: 2,
          label: '2: Particuliere verhuurder',
          value: 'Particuliere verhuurder',
          active: true,
          color: 'rgb(246, 104, 50)'
        },  
        {
          id: 'eigenaar-4',
          code: 3,
          label: '3: Tweede woning',
          value: 'Tweede woning',
          active: true,
          color: 'rgb(238, 207, 65)'
        }, 
        {
          id: 'eigenaar-1',
          code: 4,
          label: '4: Woningcorporatie',
          value: 'Woningcorporatie',
          active: true,
          color: 'rgb(21, 193, 203)'
        }, 
        {
          id: 'eigenaar-5',
          code: 5,
          label: '5: Overig',
          value: 'Overig',
          active: true,
          color: 'rgb(74, 93, 161)'
        }, 
        {
          id: 'eigenaar-3',
          code: 6,
          label: '6: Meerdere',
          value: 'Meerdere',
          active: true,
          color: 'rgb(38, 179, 137)'
        }, 
        {
          id: 'eigenaar-6',
          code: 7,
          label: '7: Onbekend',
          value: 'n.b.', // TODO: also null
          active: false,
          color: '#cc232a'
        }
      ]
    },
    energielabel: {
      id: 'energielabel',
      label: 'Energielabel',
      component: true,
      enabled: true,
      position: 1,
      maporder: 1,
      items: [{
        id: 'energielabel-0',
        code: 'A',
        label: 'A',
        value: 'A',
        active: true,
        color: '#33a357'
      },{
        id: 'energielabel-1',
        code: 'B',
        label: 'B',
        value: 'B',
        active: true,
        color: '#79b752'
      }, {
        id: 'energielabel-2',
        code: 'C',
        label: 'C',
        value: 'C',
        active: false,
        color: '#c3d545'
      }, {
        id: 'energielabel-3',
        code: 'D',
        label: 'D',
        value: 'D',
        active: true,
        color: '#fff12c'
      }, {
        id: 'energielabel-4',
        code: 'E',
        label: 'E',
        value: 'E',
        active: true,
        color: '#fff12c'
      }, {
        id: 'energielabel-5',
        code: 'F',
        label: 'F',
        value: 'F',
        active: true,
        color: '#d66f2c'
      }, {
        id: 'energielabel-6',
        code: 'G',
        label: 'G',
        value: 'G',
        active: true,
        color: '#cc232a'
      }, {
        id: 'energielabel-7',
        code: 'M',
        label: 'M (Meerdere)',
        value: 'M',
        active: true,
        color: 'hsl(239, 94%, 19%)'
      }, {
        id: 'energielabel-8',
        code: 'O',
        label: 'O (Onbekend)',
        value: 'O',
        active: true,
        color: 'hsl(201, 100%, 36%)'
      }]
    },
    
    wozwaardeklasse: {
      id: 'wozwaardeklasse',
      label: 'WOZ Waarde Klasse',
      component: true,
      enabled: true,
      position: 2,
      maporder: 2,
      items: [{
        id: 'wozwaardeklasse-0',
        code: 1,
        label: '1: minder dan €100K',
        value: 'minder dan €100.000',
        active: true,
        color: 'rgb(245, 63, 174)'
      },{
        id: 'wozwaardeklasse-1',
        code: 2,
        label: '2: €100K tot €150K',
        value: '€100.000 tot €150.000',
        active: true,
        color: 'rgb(21, 193, 203)'
      }, {
        id: 'wozwaardeklasse-2',
        code: 3,
        label: '3: €150K tot €200K',
        value: '€150.000 tot €200.000',
        active: true,
        color: 'rgb(246, 104, 50)'
      }, {
        id: 'wozwaardeklasse-3',
        code: 4,
        label: '4: €200K tot €250K',
        value: '€200.000 tot €250.000',
        active: true,
        color: 'rgb(38, 179, 137)'
      }, {
        id: 'wozwaardeklasse-4',
        code: 5,
        label: '5: €250K tot €300K',
        value: '€250.000 tot €300.000',
        active: true,
        color: 'rgb(238, 207, 65)'
      }, {
        id: 'wozwaardeklasse-5',
        code: 6,
        label: '6: €300K of meer',
        value: '€300.000 of meer',
        active: true,
        color: 'rgb(74, 93, 161)'
      }, {
        id: 'wozwaardeklasse-6',
        code: 7,
        label: '7: Meerdere',
        value: 'Meerdere',
        active: true,
        color: '#cc232a'
      }, {
        id: 'wozwaardeklasse-7',
        code: 8,
        label: '8: Onbekend',
        value: 'n.b.', // TODO: Also null
        active: true,
        color: 'hsl(239, 94%, 19%)'
      }]
    },
    bouwjaarklasse: {
      id: 'bouwjaarklasse',
      label: 'Bouwperiode Klasse',
      component: true,
      enabled: false,
      position: 3,
      maporder: 3,
      items: [
        {
          id: 'bouwjaarklasse-0',
          code: 1,
          label: '1: Voor 1946',
          value: 'Voor 1946',
          active: true,
          color: 'hsl(239, 94%, 19%)'
        },
        {
          id: 'bouwjaarklasse-1',
          code: 2,
          label: '2: 1946 - 1964',
          value: '1946 - 1964',
          active: true,
          color: 'hsl(214, 97%, 27%)'
        },
        {
          id: 'bouwjaarklasse-2',
          code: 3,
          label: '3: 1965 - 1974',
          value: '1965 - 1974',
          active: true,
          color: 'hsl(201, 100%, 36%)'
        },
        {
          id: 'bouwjaarklasse-3',
          code: 4,          
          label: '4: 1975 - 1991',
          value: '1975 - 1991',
          active: true,
          color: 'hsl(195, 100%, 39%)'
        },
        {
          id: 'bouwjaarklasse-4',
          code: 5,
          label: '5: 1992 - 2005',
          value: '1992 - 2005',
          active: true,
          color: 'hsl(190, 100%, 42%)'
        },
        {
          id: 'bouwjaarklasse-5',
          code: 6,
          label: '6: Na 2006',
          value: 'Na 2006',
          active: true,
          color: 'hsl(190, 74%, 59%)'
        }
      ]
    },
    stedelijk_hitte_eiland_effect_25: {
      id: 'stedelijk_hitte_eiland_effect_25',
      label: 'Hitte eiland (25m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 4,
      maporder: 4,
      items: [
        {
          id: 'stedelijk_hitte_eiland_effect_25-0',
          code: 1,
          label: '1: 0 t/m 0.4 graden',
          value: 1,
          tooltip: '0 t/m 0.4 graden',
          active: true,
          color: '#000CD6'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_25-1',
          code: 2,
          label: '2: 0.4 t/m 0.8 graden',
          value: 2,
          tooltip: '0.4 t/m 0.8 graden',
          active: true,
          color: '#008DD8'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_25-2',
          code: 3,
          label: '3: 0.8 t/m 1.2 graden',
          value: 3,
          tooltip: '0.8 t/m 1.2 graden',
          active: true,
          color: '#96D692'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_25-3',
          code: 4,
          label: '4: 1.2 t/m 1.6 graden',
          value: 4,
          tooltip: '1.2 t/m 1.6 graden',
          active: true,
          color: '#FDD830'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_25-4',
          code: 5,
          label: '5: 1.6 t/m 2 graden',
          value: 5,
          tooltip: '1.6 t/m 2 graden',
          active: true,
          color: '#F77321'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_25-5',
          code: 6,
          label: '6: 2+ graden',
          value: 6,
          tooltip: '2+ graden',
          active: true,
          color: '#AD0000'
        }
      ]
    }, 
    hittekaart_gevoelstemperatuur_25: {
      id: 'hittekaart_gevoelstemperatuur_25',
      label: 'Gevoelstemperatuur (25m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 5,
      maporder: 5,
      items: [
        {
          id: 'hittekaart_gevoelstemperatuur_25-0',
          code: 1,
          label: '1: < 26 graden',
          value: 1,
          tooltip: '< 26 graden',
          active: true,
          color: '#954986'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-1',
          code: 2,
          label: '2: 26 t/m 30 graden',
          value: 2,
          tooltip: '26 t/m 30 graden',
          active: true,
          color: '#8ED3F6'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-2',
          code: 3,
          label: '3: 30 t/m 34 graden',
          value: 3,
          tooltip: '30 t/m 34 graden',
          active: true,
          color: '#ACFDC8'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-3',
          code: 4,
          label: '4: 34 t/m 38 graden',
          value: 4,
          tooltip: '34 t/m 38 graden',
          active: true,
          color: '#FFFE73'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-4',
          code: 5,
          label: '5: 38 t/m 42 graden',
          value: 5,
          tooltip: '38 t/m 42 graden',
          active: true,
          color: '#FEA835'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-5',
          code: 6,
          label: '5: 42 t/m 46 graden',
          value: 6,
          tooltip: '42 t/m 46 graden',
          active: true,
          color: '#E72E02'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_25-6',
          code: 7,
          label: '6: 46 t/m 49 graden',
          value: 7,
          tooltip: '46 t/m 49 graden',
          active: true,
          color: '#730000'
        }
      ]
    }, 
    waterdiepte_bij_intense_neerslag_1_100_jaar_25: {
      id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25',
      label: 'Waterdiepte bij neerslag t/m 100 jaar (25m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 6,
      maporder: 6,
      items: [
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25-0',
          code: 1,
          label: '1: 5 t/m 10 cm',
          value: 1,
          tooltip: '5 t/m 10 cm',
          active: true,
          color: '#B6EDF0'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25-1',
          code: 2,
          label: '2: 10 t/m 15 cm',
          value: 2,
          tooltip: '10 t/m 15 cm',
          active: true,
          color: '#74B4E8'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25-2',
          code: 3,
          label: '3: 15 t/m 20 cm',
          value: 3,
          tooltip: '15 t/m 20 cm',
          active: true,
          color: '#2183E1'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25-3',
          code: 4,
          label: '4: 20 t/m 25 cm',
          value: 4,
          tooltip: '20 t/m 25 cm',
          active: true,
          color: '#1A45B7'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_25-4',
          code: 5,
          label: '5: > 30 cm',
          value: 5,
          tooltip: '> 30 cm',
          active: true,
          color: '#002674'
        }
      ]
    },
    waterdiepte_bij_intense_neerslag_1_1000_jaar_25: {
      id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25',
      label: 'Waterdiepte bij neerslag t/m 1000 jaar (25m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 7,
      maporder: 7,
      items: [
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25-0',
          code: 1,
          label: '1: 5 t/m 10 cm',
          value: 1,
          tooltip: '5 t/m 10 cm',
          active: true,
          color: '#B6EDF0'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25-1',
          code: 2,
          label: '2: 10 t/m 15 cm',
          value: 2,
          tooltip: '10 t/m 15 cm',
          active: true,
          color: '#74B4E8'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25-2',
          code: 3,
          label: '3: 15 t/m 20 cm',
          value: 3,
          tooltip: '15 t/m 20 cm',
          active: true,
          color: '#2183E1'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25-3',
          code: 4,
          label: '4: 20 t/m 25 cm',
          value: 4,
          tooltip: '20 t/m 25 cm',
          active: true,
          color: '#1A45B7'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_25-4',
          code: 5,
          label: '5: > 30 cm',
          value: 5,
          tooltip: '> 30 cm',
          active: true,
          color: '#002674'
        }
      ]
    },
    stedelijk_hitte_eiland_effect_500: {
      id: 'stedelijk_hitte_eiland_effect_500',
      label: 'Hitte eiland (500m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 8,
      maporder: 8,
      items: [
        {
          id: 'stedelijk_hitte_eiland_effect_500-0',
          code: 1,
          label: '1: 0 t/m 0.4 graden',
          value: 1,
          tooltip: '0 t/m 0.4 graden',
          active: true,
          color: '#000CD6'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_500-1',
          code: 2,
          label: '2: 0.4 t/m 0.8 graden',
          value: 2,
          tooltip: '0.4 t/m 0.8 graden',
          active: true,
          color: '#008DD8'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_500-2',
          code: 3,
          label: '3: 0.8 t/m 1.2 graden',
          value: 3,
          tooltip: '0.8 t/m 1.2 graden',
          active: true,
          color: '#96D692'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_500-3',
          code: 4,
          label: '4: 1.2 t/m 1.6 graden',
          value: 4,
          tooltip: '1.2 t/m 1.6 graden',
          active: true,
          color: '#FDD830'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_500-4',
          code: 5,
          label: '5: 1.6 t/m 2 graden',
          value: 5,
          tooltip: '1.6 t/m 2 graden',
          active: true,
          color: '#F77321'
        },
        {
          id: 'stedelijk_hitte_eiland_effect_500-5',
          code: 6,
          label: '6: 2+ graden',
          value: 6,
          tooltip: '2+ graden',
          active: true,
          color: '#AD0000'
        }
      ]
    },
    hittekaart_gevoelstemperatuur_500: {
      id: 'hittekaart_gevoelstemperatuur_500',
      label: 'Gevoelstemperatuur (500m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 9,
      maporder: 9,
      items: [
        {
          id: 'hittekaart_gevoelstemperatuur_500-0',
          code: 1,
          label: '1: < 26 graden',
          value: 1,
          tooltip: '< 26 graden',
          active: true,
          color: '#954986'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-1',
          code: 2,
          label: '2: 26 t/m 30 graden',
          value: 2,
          tooltip: '26 t/m 30 graden',
          active: true,
          color: '#8ED3F6'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-2',
          code: 3,
          label: '3: 30 t/m 34 graden',
          value: 3,
          tooltip: '30 t/m 34 graden',
          active: true,
          color: '#ACFDC8'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-3',
          code: 4,
          label: '4: 34 t/m 38 graden',
          value: 4,
          tooltip: '34 t/m 38 graden',
          active: true,
          color: '#FFFE73'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-4',
          code: 5,
          label: '5: 38 t/m 42 graden',
          value: 5,
          tooltip: '38 t/m 42 graden',
          active: true,
          color: '#FEA835'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-5',
          code: 6,
          label: '5: 42 t/m 46 graden',
          value: 6,
          tooltip: '42 t/m 46 graden',
          active: true,
          color: '#E72E02'
        },
        {
          id: 'hittekaart_gevoelstemperatuur_500-6',
          code: 7,
          label: '6: 46 t/m 49 graden',
          value: 7,
          tooltip: '46 t/m 49 graden',
          active: true,
          color: '#730000'
        }
      ]
    }, 
    waterdiepte_bij_intense_neerslag_1_100_jaar_500: {
      id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500',
      label: 'Waterdiepte bij neerslag t/m 100 jaar (500m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 10,
      maporder: 10,
      items: [
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500-0',
          code: 1,
          label: '1: 5 t/m 10 cm',
          value: 1,
          tooltip: '5 t/m 10 cm',
          active: true,
          color: '#B6EDF0'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500-1',
          code: 2,
          label: '2: 10 t/m 15 cm',
          value: 2,
          tooltip: '10 t/m 15 cm',
          active: true,
          color: '#74B4E8'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500-2',
          code: 3,
          label: '3: 15 t/m 20 cm',
          value: 3,
          tooltip: '15 t/m 20 cm',
          active: true,
          color: '#2183E1'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500-3',
          code: 4,
          label: '4: 20 t/m 25 cm',
          value: 4,
          tooltip: '20 t/m 25 cm',
          active: true,
          color: '#1A45B7'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_100_jaar_500-4',
          code: 5,
          label: '5: > 30 cm',
          value: 5,
          tooltip: '> 30 cm',
          active: true,
          color: '#002674'
        }
      ]
    },
    waterdiepte_bij_intense_neerslag_1_1000_jaar_500: {
      id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500',
      label: 'Waterdiepte bij neerslag t/m 1000 jaar (500m)',
      component: true,
      enabled: true,
      categorical: true,
      position: 11,
      maporder: 11,
      items: [
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500-0',
          code: 1,
          label: '1: 5 t/m 10 cm',
          value: 1,
          tooltip: '5 t/m 10 cm',
          active: true,
          color: '#B6EDF0'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500-1',
          code: 2,
          label: '2: 10 t/m 15 cm',
          value: 2,
          tooltip: '10 t/m 15 cm',
          active: true,
          color: '#74B4E8'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500-2',
          code: 3,
          label: '3: 15 t/m 20 cm',
          value: 3,
          tooltip: '15 t/m 20 cm',
          active: true,
          color: '#2183E1'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500-3',
          code: 4,
          label: '4: 20 t/m 25 cm',
          value: 4,
          tooltip: '20 t/m 25 cm',
          active: true,
          color: '#1A45B7'
        },
        {
          id: 'waterdiepte_bij_intense_neerslag_1_1000_jaar_500-4',
          code: 5,
          label: '5: > 30 cm',
          value: 5,
          tooltip: '> 30 cm',
          active: true,
          color: '#002674'
        }
      ]
    },
  },
}

const getters = {
  getActiveMunicipality: state => state.municipality,
  getActiveMunicipalityInfo: state => state.municipalities[state.municipality],

  getActiveNeighborhood: state => state.neighborhood,
  getActiveNeighborhoodInfo: state => state.municipalities[state.municipality].neighborhoods[state.neighborhood],
  getNeighborhoodInfo: state => ({ neighborhood }) => state.municipalities[state.municipality].neighborhoods[neighborhood],

  getFilterInfo: state => ({ mode }) => mode === null ? state.filters : state.filters[mode],
  getAllFilterInfo: state => state.filters,

  getActiveFilters: state => 
    Object.keys(state.filters)
      .reduce((result, key) => {
        result[key] = state.filters[key].items.filter(item => item.active)
        return result
      }, {}),
  getDisabledFilters: state => 
    Object.keys(state.filters)
      .filter(key => !!state.filters[key].enabled)
      .reduce((result, key) => {
        let prop = state.filters[key].categorical ? `${key}_code` : key;

        result[prop] = state.filters[key].items.filter(item => !item.active)
        return result
      }, {}),

  /**
   * Get the id's of the active barcode components, in the order that they are active
   */
  getActiveBarcodeComponents: state => {
    return Object.values(state.filters)
      .filter(filter => {
        return filter.component && !!filter.enabled
      })
      .sort((a,b) => a > b ? -1 : 1)
  }
}
const actions = {
  
}
const mutations = {
  setMunicipality(state, { municipality }) {
    if (municipality in state.municipalities) {
      state.municipality = municipality
    }
  },
  setNeighborhood(state, { neighborhood }) {
    /**
     * Only accept the neighbprhood value if it exists within the active municipality
     */
    if (state.municipalities[state.municipality].neighborhoods[neighborhood]) {
      state.neighborhood = neighborhood
    }
  },
  /**
   * Upon being passed a list of filter item ids, the active state of all filter items is set
   */
  restoreFilterSettings(state, { activeIds }) {
    Object.values(state.filters).forEach(filter => {
      if (filter.id !== 'barcode') {
        filter.items.forEach(item => item.active = activeIds.includes(item.id))
      }
    })
  },
  /**
   * Upon being passed a list of barcode components, the active state of barcode components is set
   */
  restoreActiveComponents(state, { components }) {
    Object.values(state.filters).filter(filter => filter.component).forEach(filter => {
      filter.enabled = components.includes(filter.id)
    })
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
